import dayjs from "dayjs";
import type {
  Order,
  OrderEditHistory,
  OrderItem,
  OrderPayment,
} from "../../Types/Order";

export type AuditLog = OrderEditHistory;

export type LegacyHistoryItem = OrderItem & {
  deleted_at?: string;
};

export type LegacyHistoryPayment = OrderPayment & {
  deleted_at?: string;
};

export interface OrderHistoryData {
  auditLogs: AuditLog[];
  legacyItems: LegacyHistoryItem[];
  legacyPayments: LegacyHistoryPayment[];
  hasAuditLogs: boolean;
  hasLegacyLogs: boolean;
  hasHistory: boolean;
}

const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm";
const DATE_TIME_WITH_SECONDS_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const formatAmount = (value: number | string | null | undefined) => {
  const amount = Number(value);

  return Number.isFinite(amount)
    ? amount.toLocaleString(undefined, { minimumFractionDigits: 2 })
    : "0.00";
};

export const formatHistoryDate = (
  value: string | null | undefined,
  includeSeconds = false,
) => {
  if (!value) {
    return "N/A";
  }

  const parsed = dayjs(value);

  return parsed.isValid()
    ? parsed.format(
        includeSeconds ? DATE_TIME_WITH_SECONDS_FORMAT : DATE_TIME_FORMAT,
      )
    : "N/A";
};

export const getOrderHistory = (
  order: Order | null | undefined,
): OrderHistoryData => {
  const auditLogs = order?.edit_history ?? [];
  const legacyItems = (order?.history_items ?? []) as LegacyHistoryItem[];
  const legacyPayments = (order?.history_payments ??
    []) as LegacyHistoryPayment[];
  const hasAuditLogs = auditLogs.length > 0;
  const hasLegacyLogs = legacyItems.length > 0 || legacyPayments.length > 0;

  return {
    auditLogs,
    legacyItems,
    legacyPayments,
    hasAuditLogs,
    hasLegacyLogs,
    hasHistory: hasAuditLogs || hasLegacyLogs,
  };
};
